import { NgModule } from "@angular/core";
import {
    RouterModule,
    Router,
    NavigationEnd,
    RouteConfigLoadStart,
    RouteConfigLoadEnd,
} from "@angular/router";
import { NotificationsComponent } from "./shared/layout/notifications/notifications.component";
import { AppComponent } from "./app.component";
import { AppRouteGuard } from "./shared/common/auth/auth-route-guard";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: "app",
                component: AppComponent,
                canActivate: [AppRouteGuard],
                canActivateChild: [AppRouteGuard],
                children: [
                    {
                        path: "",
                        children: [
                            {
                                path: "notifications",
                                component: NotificationsComponent,
                            },
                            {
                                path: "",
                                redirectTo: "/dashboard",
                                pathMatch: "full",
                            },
                        ],
                    },
                    {
                        path: "main",
                        loadChildren: "app/main/main.module#MainModule", //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: "admin",
                        loadChildren: "app/admin/admin.module#AdminModule", //Lazy load admin module
                        data: { preload: true },
                    },
                    {
                        path: "backoffice",
                        loadChildren:
                            "app/backoffice/backoffice.module#BackOfficeModule", //Lazy load backoffice module
                        data: { preload: true },
                    },
                    {
                        path: "ecoSystems",
                        loadChildren:
                            "app/eco-system/eco-system.module#EcoSystemModule", //Lazy load backoffice module
                        data: { preload: true },
                    },
                    {
                        path: "frontoffice",
                        loadChildren:
                            "app/frontoffice/frontoffice.module#FrontOfficeModule", //Lazy load backoffice module
                        data: { preload: true },
                    },
                    {
                        path: "reports",
                        loadChildren:
                            "app/reports/reports.module#ReportsModule", //Lazy load backoffice module
                        data: { preload: true },
                    },
                     {
                        path: "operations-reports",
                        loadChildren:
                            "app/devices-managment-reports/devices-managment-reports.module#DevicesManagmentReportsModule", //Lazy load backoffice module
                        data: { preload: true },
                    },
                    {
                        path: "MarketPlace",
                        loadChildren:
                            "app/MarketPlace/marketplace.module#MarketPlaceModule", //Lazy load backoffice module
                        data: { preload: true },
                    },

                    {
                        path: "**",
                        redirectTo: "notifications",
                    },
                ],
            },
        ]),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
    constructor(private router: Router) {
        router.events.subscribe((event) => {
            if (event instanceof RouteConfigLoadStart) {
                abp.ui.setBusy();
            }

            if (event instanceof RouteConfigLoadEnd) {
                abp.ui.clearBusy();
            }

            if (event instanceof NavigationEnd) {
                $("meta[property=og\\:url]").attr(
                    "content",
                    window.location.href,
                );
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts